import { useQuery } from "react-query";
import { getDataWithDotNet } from "../newApis/dotNetApiMethods";
import * as ajaxEndpoints from "../api/ajax-endpoints";

const getAllGender = async (code) => {
  const { data } = await getDataWithDotNet(
    `${ajaxEndpoints.GET_ALL_GENDER}?countryCode=${code}`
  );
  return data;
};

export default function useAllGender(code) {
  return useQuery([code, "getAllGender"], getAllGender, {
    enabled: code? true:false,
    refetchOnWindowFocus: false,
  });
}
